<template>
    <!-- <NavBar /> -->
    <HomePage />
    <!-- <IntroductionHome/> -->
    <SkillsComponent/>
    <EducationAndExperience/>
    <!-- <LoveToCode /> -->
    <CodingPlatforms/>
    <CertificatesComponent/>
    <LinkedInInteraction />
    <Services />
    <ContactComponent />
    <FooterComponent />
</template>

<script>
import { defineComponent } from 'vue';
import EducationAndExperience from '@/components/EducationAndExperience.vue';
import HomePage from '@/components/HomePage.vue';
import IntroductionHome from '../components/Introduction.vue';
import SkillsComponent from '../components/Skills.vue';
import ContactComponent from '../components/Contact.vue';
import LoveToCode from '../components/LoveToCode.vue';
import Services from '../components/Services.vue';
import NavBar from '../components/Navbar.vue';
import FooterComponent from '../components/Footer.vue';
import CodingPlatforms from '@/components/CodingPlatforms.vue';
import CertificatesComponent from '@/components/Certificates.vue';
import LinkedInInteraction from '@/components/LinkedInInteraction.vue';

export default defineComponent({
  name: 'HomeView',

  components: {
    HomePage,
    IntroductionHome,
    EducationAndExperience,
    SkillsComponent,
    ContactComponent,
    LoveToCode,
    Services,
    LinkedInInteraction,
    NavBar,
    FooterComponent,
    CodingPlatforms,
    CertificatesComponent
  },
});
</script>
